import { Observable, from, mergeMap, toArray } from 'rxjs';

export const ThrottledForkJoin = <T>(observablesArray: Observable<T>[], concurrency: number) => {
  return from(observablesArray).pipe(
    mergeMap(observable => observable, concurrency),
    toArray()
  );
};
